import { z } from 'zod';

export const searchSchema = z.object({
  location: z.string(),
  dates: z.object({
    arrival: z.string().date(),
    departure: z.string().date(),
  }),
  guests: z.object({
    adults: z.number().min(1),
    children: z.number().min(0),
    infants: z.number().min(0),
  }),
});
export type SearchSchema = z.infer<typeof searchSchema>;
